import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import Chart, { ChartData } from 'chart.js/auto';

@Component({
    selector: 'cv-weekly-chart',
    templateUrl: 'weekly-chart.component.html',
    styleUrls: ['weekly-chart.component.scss']
})

export class WeeklyChartComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() type: 'bar'|'line' = 'bar';
    @Input() data!: ChartData;
    @Input() options: any = {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,       // disable jumpy animations
    };
    @Input() title = '';
  
    @ViewChild('chart') chartRef!: ElementRef<HTMLCanvasElement>;
    private chart?: Chart;
  
    ngAfterViewInit() {
      this.createChart();
    }
  
    ngOnChanges(changes: SimpleChanges) {
      if (this.chart && (changes['data'] || changes['options'])) {
        this.chart.destroy();     // ← step 1: tear down previous
        this.createChart();       // ← step 2: rebuild with the exact same canvas size
      }
    }
    
    /**
     * Initializes the chart context.
     * @returns {void}
     */
    private createChart(): void {
      this.chart = new Chart(this.chartRef.nativeElement.getContext('2d')!, {
        type: this.type,
        data: this.data,
        options: this.options
      });
    }
  
    ngOnDestroy() {
      this.chart?.destroy();
    }
  }